import { envConfig } from '~/utils/env';
import { BaseRestRepository } from './baseRestRepository';
import type { CreateCustomViewDto, CustomViewDto, CustomViewType } from '~/swagger/settings/Api';

const BASE_URL = `${envConfig.service.settings}/company-portal/settings/custom-views`;

export class CustomViewsRepository extends BaseRestRepository {
  public async createCustomView(type: CustomViewType, payload: CreateCustomViewDto): Promise<CustomViewDto> {
    if (!type) throw new Error('Type must be provided');
    const url = `${BASE_URL}/${type}`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async getCustomViews(type: CustomViewType): Promise<CustomViewDto[]> {
    if (!type) throw new Error('Type must be provided');
    const url = `${BASE_URL}/${type}`;
    const response = await this.fetchWithAuth(url, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }

  public async getCustomView(type: CustomViewType, key: string): Promise<CustomViewDto> {
    if (!type) throw new Error('Type must be provided');
    if (!key) throw new Error('Key must be provided');
    const url = `${BASE_URL}/${type}/${key}`;
    const response = await this.fetchWithAuth(url, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }

  public async updateCustomView(type: CustomViewType, key: string, payload: CreateCustomViewDto): Promise<CustomViewDto> {
    if (!type) throw new Error('Type must be provided');
    if (!key) throw new Error('Key must be provided');
    const url = `${BASE_URL}/${type}/${key}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async deleteCustomView(type: CustomViewType, key: string): Promise<void> {
    if (!type) throw new Error('Type must be provided');
    if (!key) throw new Error('Key must be provided');
    const url = `${BASE_URL}/${type}/${key}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}

export const customViewsRepository = new CustomViewsRepository();
